import React from "react";
import { Plus, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Scene names used in notes but not on the director's list: add, merge into a listed scene, or dismiss.
export default function SceneReviewList({ review, items, onAdd, onMerge, onDismiss }) {
  if (!review.length) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/60 p-3" data-testid="scene-review">
      <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-amber-700"><Sparkles className="h-3.5 w-3.5" /> New – needs review</p>
      <p className="mb-1 text-xs text-amber-800/80">Typed in notes but not on your list yet.</p>
      {review.map((r, i) => (
        <div key={r.name} className="flex flex-wrap items-center gap-2 border-t border-amber-200/70 py-2 first:border-0" data-testid={`scene-review-row-${i}`}>
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium text-slate-900" data-testid={`scene-review-name-${i}`}>{r.name}</p>
            <p className="text-[11px] text-slate-500">Used in {r.uses} note{r.uses === 1 ? "" : "s"}</p>
          </div>
          <Button type="button" size="sm" variant="outline" className="h-8 rounded-full bg-white" onClick={() => onAdd(r)} data-testid={`scene-review-add-${i}`}>
            <Plus className="mr-1 h-3.5 w-3.5" /> Add
          </Button>
          <Select onValueChange={(id) => onMerge(r, id)} disabled={!items.length}>
            <SelectTrigger className="h-8 w-40 bg-white text-xs" data-testid={`scene-review-merge-${i}`}><SelectValue placeholder="Merge into…" /></SelectTrigger>
            <SelectContent>
              {items.map((it, j) => <SelectItem key={it.id} value={it.id} data-testid={`scene-review-merge-${i}-opt-${j}`}>{it.name || `Scene ${j + 1}`}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button type="button" size="sm" variant="ghost" className="h-8 text-slate-500" onClick={() => onDismiss(r)} data-testid={`scene-review-dismiss-${i}`}>Dismiss</Button>
        </div>
      ))}
    </div>
  );
}
